import { ImageWidgetPage, SystemConfiguration, ThemeConfig } from '../config.type';
import { APP_ZONES_TITLE, SystemZones } from '../workflow.type';
import { ALERT_STYLE_CONFIGURATION_CONSTANTS } from './default-configurations-alerts/get-custom-alert-configuration';
import { defaultNavBar } from './workflow-constants.type';

export const defaultZonesConfig = {
  onboarding: {
    title: APP_ZONES_TITLE.ONBOARDING_PAGE,
    roles: {},
  },
  verification_zone: {
    title: APP_ZONES_TITLE.VERIFICATION,
    roles: {},
  },
  landing_zone: {
    title: APP_ZONES_TITLE.LANDING,
    roles: {},
  },
  profile_zone: {
    title: APP_ZONES_TITLE.PROFILE,
    roles: {},
  },
  payments_zone: {
    title: APP_ZONES_TITLE.PAYMENT,
    roles: {},
  },
  general_zone: {
    title: APP_ZONES_TITLE.GENERAL,
    roles: {},
  },
  card_management_zone: {
    title: APP_ZONES_TITLE.CARD_MANAGEMENT_ZONE,
    roles: {},
  },
} as SystemZones;

export const defaultTheme = {
  fontFamily: 'Mulish',
  colour_palette: {
    name: 'default',
    palette: {
      '0': '#dfe1e3',
      '1': '#c0c2c6',
      '2': '#9c9ea3',
      '3': '#00d8be',
      '4': '#00302a',
      '5': '#000b0c',
      '6': '#080808',
    },
    border_colors: {
      '0': '#00d8be',
      '1': '#00302a',
      '2': '#9c9ea3',
    },
    typography: {
      palette: {
        '0': '#dfe1e3',
        '1': '#c0c2c6',
        '2': '#9c9ea3',
      },
    },
    neutrals: {
      '0': '#9c9ea3',
      '1': '#00302a',
      '2': '#000b0c',
      '3': '#080808',
    },
    alerts: {
      '0': '#FF2323',
      '1': '#1EA97C',
      '2': '#696CFF',
      '3': '#CC8925',
    },
  },
  logo: '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',
} as ThemeConfig;

export const defaultSystemConfiguration = {
  roles: {},
  subscription: {
    default: {
      title: 'default',
    },
    gold: {
      title: 'gold',
    },
    silver: {
      title: 'silver',
    },
    bronze: {
      title: 'bronze',
    },
  },
  ui: {
    system: {
      systemName: '',
      legalEntityName: '',
      theme: defaultTheme,
      loginPageConfig: {
        logoEnabled: true,
      },
    },
    zones: defaultZonesConfig,
    navbar: { defaultRole: defaultNavBar },
    customData: {
      data: {},
      questions: {},
    },
  },
} as SystemConfiguration;

export const defaultSystemConfig = {
  roles: {},
  subscription: {
    default: {
      title: 'default',
    },
    gold: {
      title: 'gold',
    },
    silver: {
      title: 'silver',
    },
    bronze: {
      title: 'bronze',
    },
  },
  ui: {
    system: {
      systemName: 'MoneyFin',
      legalEntityName: 'MoneyFin Ltd',
      theme: defaultTheme,
      loginPageConfig: {
        logoEnabled: false,
      },
    },
    zones: defaultZonesConfig,
    navbar: { defaultRole: defaultNavBar },
    customData: {
      data: {},
      questions: {},
    },
    alertsConfig: ALERT_STYLE_CONFIGURATION_CONSTANTS,
  },
  kyc_regulated: true,
} as SystemConfiguration;

export const defaultImageWidget = {
  organisations: {
    group: {
      additional_fields: [],
    },
    individual: {
      additional_configs: {
        additional_fields: [],
        validators: [],
      },
      layout: [
        {
          uniqueId: 1685031952671,
          name: 'image_widget',
          type: 'display_widget',
          position: 3,
          attributes: {
            show: true,
            label: 'Image',
            sub_heading: '',
            decision_config: {
              required: true,
            },
            field_attributes: [
              {
                name: 'image',
                type: 'image',
                label: 'Image.png',
                options: [],
                additional_config: {
                  id: 'https://placehold.co/600x300?text=Image+Widget',
                  show: true,
                },
              },
            ],
          },
          gridPosition: undefined,
        },
      ],
    },
  },
} as ImageWidgetPage;
